module.exports = __webpack_public_path__ + "img/home.8a95ee9e.svg";